var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashBoardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.52,
    height: 13.52,
    viewBox: "0 0 13.52 13.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58343",
    "data-name": "Group 58343",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58346",
    "data-name": "Group 58346",
    transform: "translate(2.25 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42256",
    "data-name": "Path 42256",
    d: "M11.09,3.29a.52.52,0,1,0,0-1.04H8.979c-1.274,0-2.271,0-3.064.086a4.034,4.034,0,0,0-2.022.675,3.987,3.987,0,0,0-.882.882,4.034,4.034,0,0,0-.675,2.022c-.086.792-.086,1.79-.086,3.064v.062c0,1.274,0,2.271.086,3.063a4.037,4.037,0,0,0,.675,2.022,3.987,3.987,0,0,0,.882.882,4.034,4.034,0,0,0,2.022.675c.792.086,1.79.086,3.064.086h.062c1.274,0,2.271,0,3.064-.086a4.034,4.034,0,0,0,2.022-.675,3.986,3.986,0,0,0,.882-.882,4.034,4.034,0,0,0,.675-2.022c.086-.792.086-1.79.086-3.064V6.93a.52.52,0,0,0-1.04,0V9.01c0,1.312,0,2.253-.08,2.983a3.03,3.03,0,0,1-.483,1.523,2.965,2.965,0,0,1-.652.652,3.016,3.016,0,0,1-1.523.483c-.729.079-1.671.08-2.983.08s-2.253,0-2.983-.08A3.03,3.03,0,0,1,4.5,14.167a2.947,2.947,0,0,1-.652-.652,3.016,3.016,0,0,1-.483-1.523c-.079-.729-.08-1.671-.08-2.983s0-2.253.08-2.983A3.023,3.023,0,0,1,3.853,4.5,2.965,2.965,0,0,1,4.5,3.853,3.016,3.016,0,0,1,6.027,3.37c.729-.079,1.671-.08,2.983-.08Z",
    transform: "translate(-2.25 -1.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42257",
    "data-name": "Path 42257",
    d: "M6.307,12.9a.562.562,0,0,0,.248.719.514.514,0,0,0,.695-.235L8.274,11.2a.821.821,0,0,1,1.523.054,1.852,1.852,0,0,0,3.438.122l1.023-2.185a.562.562,0,0,0-.248-.719.514.514,0,0,0-.695.235l-1.023,2.185a.821.821,0,0,1-1.523-.054,1.852,1.852,0,0,0-3.438-.122Z",
    transform: "translate(-3.522 -3.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42258",
    "data-name": "Path 42258",
    d: "M17.5,3.25A1.75,1.75,0,1,0,19.25,1.5,1.75,1.75,0,0,0,17.5,3.25Zm1.05,0a.7.7,0,1,0,.7-.7A.7.7,0,0,0,18.55,3.25Z",
    transform: "translate(-7.48 -0.75)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardIcon);
export default __webpack_public_path__ + "static/media/DashBoardIcon.7bc8a95aac8183b1cdf36743d80945ac.svg";
export { ForwardRef as ReactComponent };